import apiClient from "./apiClient";
import { fetchWithAuthRetry } from "./authService";
const HOME_PATH = "/api/v3/home";
const getOrgInfoApi = async () => {
  const response = await apiClient.get(`${HOME_PATH}/getOrganizationDetails`);
  return response.data;
};

const getIndustriesListApi = async () => {
  const response = await apiClient.get(`${HOME_PATH}/getAllIndustries`);
  return response.data;
};

// switch to web app
const goToWebAppApi = async (email) => {
  const response = await apiClient.post(
    `${HOME_PATH}/checkWebappAccess`,
    email,
  );
  return response.data;
};

const getCountriesListApi = async () => {
  const response = await apiClient.get(`${HOME_PATH}/getAllCountries`);
  return response.data;
};

// SAVE THE ORGANIZATION INFO
const saveOrgInfoApi = async (orgInfo) => {
  const response = await apiClient.post(
    `${HOME_PATH}/updateOrganizationDetails`,
    orgInfo,
  );
  return response.data;
};

// GET THE DEPARTMENTS LIST FOR DEPARTMENT DROPDOWN DATA
const getDepartmentsListApi = async () => {
  const response = await apiClient.get(`${HOME_PATH}/getDepartments`);
  return response.data;
};
// GET DEPARTMENTS MASTER LIST
const getDepartmentsMasterListApi = async () => {
  const response = await apiClient.get(`${HOME_PATH}/getAllMasterDepartments`);
  return response.data;
};
// ADD A NEW DEPARTMENT IN THE ORGANIZATION
const addDepartmentApi = async (department) => {
  const response = await apiClient.post(`${HOME_PATH}/createDepartment`, {
    departments: department,
  });
  return response.data;
};
// DELETE DEPARTMENT IN THE ORGANIZATION
const deleteDepartmentApi = async (departmentId) => {
  const response = await apiClient.post(`${HOME_PATH}/deleteDepartment`, {
    _id: departmentId,
  });
  return response.data;
};
// GET OVERVIEW DATA FOR THE HOME PAGE
const getOverviewDataApi = async () => {
  const response = await apiClient.get(`${HOME_PATH}/getOverviewData`);
  return response.data;
};
// GET KEY PERFORMANCE METRICS AND DASHBOARD DATA
const getKeyPerformanceMetricsApi = async () => {
  const response = await apiClient.get(`${HOME_PATH}/getKeyPerformanceMetrics`);
  return response.data;
};
// UPDATE CONSOLE USER PROFILE
const updateConsoleUserProfileApi = async (userProfile) => {
  const response = await apiClient.post(
    `${HOME_PATH}/updateConsoleUserProfile`,
    userProfile,
  );
  return response.data;
};

// GET THE ONBOARDED ORGANIZATION DETAILS
const getOnboardedOrganizationsApi = async (data) => {
  const response = await apiClient.get(
    `${HOME_PATH}/getOnboardedOrganizations?pageNo=${data.pageNo}&pageSize=${data.pageSize}&search=${data.search}&industry=${data.industry}&sort=${data.sort}&owner=${data.owner}`,
  );
  return response.data;
};
// GET ONBOARDED ORGANIZATION DETAILS BY ID
const getOnboardedOrganizationByIdApi = async (id) => {
  const response = await apiClient.get(
    `${HOME_PATH}/getOnboardedOrganizationById?id=${id}`,
  );
  return response.data;
};
// ONBOARDING ORGANIZATION API
const onboardOrganizationApi = async (orgDetails) => {
  const response = await apiClient.post(
    `${HOME_PATH}/onboardOrganization`,
    orgDetails,
  );
  return response.data;
};

// DELETE ONBOARDED ORGANIZATION API
const deleteOnboardedOrganizationApi = async (id) => {
  const response = await apiClient.get(
    `${HOME_PATH}/deleteOnboardedOrganization?id=${id}`,
  );
  return response.data;
};
// EDIT ONBOARDER ORGANIZATION API
const editOnboardedOrganizationApi = async (orgDetails) => {
  const response = await apiClient.post(
    `${HOME_PATH}/editOnboardedOrganization`,
    orgDetails,
  );
  return response.data;
};

// GET ALL CONSOLE USERS LIST
const getConsoleUsersListApi = async (data) => {
  const response = await apiClient.get(
    `${HOME_PATH}/getAllConsoleUsers?pageNo=${data.pageNo}&pageSize=${data.pageSize}&role=${data.role}&searchFilter=${data.searchFilter}&department=${data.department}&sortBy=${data.sortBy}`,
  );
  return response.data;
};

// UPDATE THE CONSOLE USER PROFILE
const updateConsoleUsersDataApi = async (userProfile) => {
  const response = await apiClient.post(
    `${HOME_PATH}/editConsoleUser`,
    userProfile,
  );
  return response.data;
};

// DELETE THE CONSOLE USER
const deleteConsoleUserApi = async (userId) => {
  const response = await apiClient.post(`${HOME_PATH}/deleteConsoleUser`, {
    consoleUserId: userId,
  });
  return response.data;
};

// ADD CONSOLE USER
const addConsoleUserApi = async (userData) => {
  const response = await apiClient.post(
    `${HOME_PATH}/addConsoleUser`,
    userData,
  );
  return response.data;
};

export const generateCompanyInfo = async (url) => {
  console.log("URL in service:", url);
  const response = await apiClient.post(
    `${HOME_PATH}/generateCompanyInfo`,
    url,
  );
  return response.data;
};

export const getAiOrganizationSuggestedRole = async () => {
  const response = await apiClient.get(
    `${HOME_PATH}/getOrganizationSuggestedRoles`,
  );
  return response.data;
};

export const saveAiGeneratedOrganizationRoles = async (data) => {
  const response = await apiClient.post(
    `${HOME_PATH}/generateCompanyJobRoles`,
    data,
  );
  return response.data;
};

export async function generateCompanyInfoStream(payload, onChunk, opts = {}) {
  const { signal, delayMs = 0, jsonField = null } = opts;

  const sleep = (ms) =>
    ms > 0 ? new Promise((r) => setTimeout(r, ms)) : Promise.resolve();

  // ✅ Build ABSOLUTE URL using axios baseURL
  const base = String(apiClient?.defaults?.baseURL || "").replace(/\/+$/, "");
  const path = String(HOME_PATH || "/api/v3/home").replace(/^\/+/, "");
  const url = `${base}/${path}/generateCompanyInfo`;

  // (Optional) sanity log
  // console.log("Streaming URL:", url);

  const res = await fetchWithAuthRetry(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "text/event-stream, text/plain;q=0.9, */*;q=0.8",
      tenantId: sessionStorage.getItem("tenantId") || "",
    },
    body: JSON.stringify(payload),
    signal,
  });

  if (!res.ok || !res.body) {
    throw new Error(`Streaming request failed with status ${res.status}`);
  }

  const contentType = (res.headers.get("content-type") || "").toLowerCase();
  const isSSE = contentType.includes("text/event-stream");

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  const emit = async (raw) => {
    if (!raw) return;
    let textToSend = raw;
    if (jsonField) {
      try {
        const obj = JSON.parse(raw);
        if (typeof obj?.[jsonField] === "string") textToSend = obj[jsonField];
      } catch {}
    }
    if (textToSend === "[DONE]" || textToSend === "__END__") return;
    await sleep(delayMs);
    onChunk(String(textToSend));
  };

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunkText = decoder.decode(value, { stream: true });

      if (isSSE) {
        buffer += chunkText;
        let idx;
        while ((idx = buffer.indexOf("\n\n")) !== -1) {
          const eventBlock = buffer.slice(0, idx);
          buffer = buffer.slice(idx + 2);

          const lines = eventBlock.split(/\r?\n/);
          const dataLines = [];
          for (const line of lines) {
            const trimmed = line.trim();
            if (!trimmed) continue;
            if (trimmed.startsWith("data:")) {
              dataLines.push(trimmed.slice(5).trimStart());
            }
          }
          if (dataLines.length) {
            await emit(dataLines.join("\n"));
          } else {
            const raw = eventBlock.trim();
            if (raw) await emit(raw);
          }
        }
      } else {
        await emit(chunkText);
      }
    }

    if (isSSE) {
      const leftover = buffer.trim();
      if (leftover) {
        const lines = leftover.split(/\r?\n/);
        const dataLines = [];
        for (const line of lines) {
          const trimmed = line.trim();
          if (!trimmed) continue;
          if (trimmed.startsWith("data:")) {
            dataLines.push(trimmed.slice(5).trimStart());
          }
        }
        if (dataLines.length) {
          await emit(dataLines.join("\n"));
        } else {
          await emit(leftover);
        }
      }
    }
  } finally {
    try {
      await reader.cancel();
    } catch {}
  }
}

export const getOrgSuggestedDepartments = async () => {
  const response = await apiClient.get(
    `${HOME_PATH}/getOrganizationSuggestedDepartments`,
  );
  return response.data;
};

export const getOrgSuggestedJobRoles = async () => {
  const response = await apiClient.get(
    `${HOME_PATH}/getOrganizationSuggestedRoles`,
  );
  return response.data;
};

export const generateCompanyJobRolesApi = async (data) => {
  const response = await apiClient.post(
    `${HOME_PATH}/generateCompanyJobRoles`,
    data,
  );
  return response.data;
};

export {
  getOrgInfoApi,
  getIndustriesListApi,
  getCountriesListApi,
  saveOrgInfoApi,
  getDepartmentsListApi,
  deleteDepartmentApi,
  addDepartmentApi,
  getDepartmentsMasterListApi,
  getOverviewDataApi,
  getKeyPerformanceMetricsApi,
  updateConsoleUserProfileApi,
  getOnboardedOrganizationsApi,
  onboardOrganizationApi,
  getConsoleUsersListApi,
  updateConsoleUsersDataApi,
  deleteConsoleUserApi,
  addConsoleUserApi,
  getOnboardedOrganizationByIdApi,
  editOnboardedOrganizationApi,
  deleteOnboardedOrganizationApi,
  goToWebAppApi,
};
